const DefenceData = [
    {
        id : "1",
        schemeName: "One Rank One Pension (OROP) Scheme",
        discription:"The review of One Rank One Pension (OROP) has been pending since June 2020. The issue was discussed during the recent parliamentary panel meet.",
        launchDate: "5 September 2005",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Agnipath Scheme",
    discription:"For recruitment of soldiers below the rank of commissioned officers into the three services of the armed forces. The Agnipath Scheme will be the only route for recruitment into the military. All recruits will be hired only for a four-year period. Personnel recruited under this system are to be called Agniveers which will be a new military rank.",
    launchDate: " year 2022",
    AnualFund: "12345"},
]
export default DefenceData;